<template>
  <div>
    <!-- v-show="isZhanShi" -->
    <div class="orderSystem w1200 b_white">
      <div class="schedule">
        <!-- <el-steps :active="active" :align-center="true">
          <el-step title="选择类型" icon="el-icon-c-scale-to-original"></el-step>
          <el-step title="填写商户信息" icon="el-icon-edit-outline"></el-step>
          <el-step title="完成" icon="el-icon-circle-check"></el-step>
        </el-steps> -->
      </div>
      <div class="content">
        <router-view />
      </div>
    </div>
    <!-- <div v-show="!isZhanShi">
      <div v-loading="loading" class="loading"></div>
    </div> -->
  </div>
</template>

<style lang="scss" scoped>
@import "./index.scss";
</style>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: true,
      active: 0,
    };
  },
  computed: mapState({
    isZhanShi: (state) => state.app.isZhanShi,
  }),
  watch: {
    $route(to) {
      if (to.path.indexOf("shopCheck") !== -1) {
        this.active = 0;
      } else if (to.path.indexOf("shopInfo") !== -1) {
        this.active = 1;
      }
    },
    immediate: true,
  },
  created() {
    if (this.$route.path.indexOf("shopCheck") !== -1) {
      this.active = 1;
    } else if (this.$route.path.indexOf("shopInfo") !== -1) {
      this.active = 2;
    }
  },
  methods: {},
};
</script>
